import { render, staticRenderFns } from "./StuSetYear.vue?vue&type=template&id=4fe5e815&scoped=true&"
import script from "./stusetyear?vue&type=script&lang=js&"
export * from "./stusetyear?vue&type=script&lang=js&"
import style0 from "./StuSetYear.vue?vue&type=style&index=0&id=4fe5e815&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe5e815",
  null
  
)

export default component.exports